export const INTRO_CONTENT = {
  welcome: 'WELCOME TO THE',
  boothName: 'DUPIXENT VIRTUAL EXPERIENCE',
  loadingMessage: 'LOADING, PLEASE WAIT',
  onboardingImageOne: "CLICK TO EXPLORE VIDEO CONTENT",
  onboardingImageTwo: "CLICK TO EXPLORE DOWNLOADABLE PDFs",
  onboardingSwipeCopy: "SWIPE LEFT/RIGHT TO EXPLORE DIFFERENT INDICATIONS"
}
